// API Configuration
// Update this URL based on your deployment:
// - For cPanel: 'https://vivy-ai.com/api' or 'https://api.vivy-ai.com'
// - For external hosting: Your hosting URL
// - For development: 'http://localhost:3001/api'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const API_ENDPOINTS = {
  newsletter: `${API_BASE_URL}/newsletter`,
  waitlist: `${API_BASE_URL}/waitlist`,
  sendBulkEmail: `${API_BASE_URL}/sendBulkEmail`,
  health: `${API_BASE_URL}/health`,
};

export default API_ENDPOINTS;

